"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _addBanner = _interopRequireDefault(require("./addBanner.vue"));
var _categoryPop = _interopRequireDefault(require("../home/components/categoryPop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    addBanner: _addBanner.default,
    categoryPop: _categoryPop.default
  },
  data: function data() {
    return {
      ruleForm: {
        showTitle: '',
        title: ''
      },
      rules: {
        showTitle: [{
          required: true,
          message: '请上选择',
          trigger: 'change'
        }],
        title: [{
          required: true,
          message: '请填写标题',
          trigger: 'blur'
        }],
        showStyle: [{
          required: true,
          message: '请上选择',
          trigger: 'change'
        }]
      },
      categoryId: '',
      puzzleList: [],
      searchStyle: '',
      shopListStyle: 0,
      realObj: {
        0: {
          text: '未开始',
          color: '#E6A23C',
          src: require('@/assets/pcl2.png')
        },
        1: {
          text: '上线中',
          color: '#67C23A',
          src: ''
        },
        2: {
          text: '已下线',
          color: '#F56C6C',
          src: require('@/assets/pcl1.png')
        }
      },
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      popTitle: '',
      title: '',
      status: '',
      showStyleOp: [{
        label: '一排三个',
        value: 0
      }, {
        label: '一排四个 ',
        value: 1
      }, {
        label: '一排五个 ',
        value: 2
      }],
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      tableData: []
    };
  },
  methods: {
    submitForm: function submitForm(formName) {
      var _this = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认保存 ?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _customPage.saveOrUpdateBanner)({
              moduleId: _this.id,
              toolbarStyle: _this.ruleForm
            }).then(function (res) {
              if (res.data) {
                _this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
              }
              _this.findList();
              _this.$emit('refresh', _this.id);
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeCategory: function changeCategory(val) {
      console.log(val.categoryId);
      this.$refs.categoryPop.open({
        bannerId: val.categoryId,
        type: 0,
        moduleId: this.id
      });
    },
    saveShopStyle: function saveShopStyle() {
      var _this2 = this;
      this.$confirm('是否确认保存 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.saveOrUpdateBanner)({
          moduleId: _this2.id,
          shopListStyle: _this2.shopListStyle
        }).then(function (res) {
          if (res.data) {
            _this2.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this2.findList();
          _this2.$emit('refresh', _this2.id);
        });
      });
    },
    saveIt: function saveIt() {
      var _this3 = this;
      this.$confirm('是否确认保存 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.saveOrUpdateBanner)({
          moduleId: _this3.id,
          searchStyle: _this3.searchStyle
        }).then(function (res) {
          if (res.data) {
            _this3.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this3.findList();
          _this3.$emit('refresh', _this3.id);
        });
      });
    },
    needRefresh: function needRefresh() {
      // 通知组件刷新（单个组件）
      this.findList();
      this.$emit('refresh', this.id);
    },
    del: function del(val) {
      var _this4 = this;
      console.log(val);
      //   deleteBanner({
      //     bannerId:val.bannerId
      //   })
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteBanner)({
          bannerId: val.bannerId
        }).then(function (res) {
          if (res.data) {
            _this4.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this4.findList();
          _this4.$emit('refresh', _this4.id);
        });
      });
    },
    onClose: function onClose() {
      this.title = '';
      this.status = '';
      this.tableData = [];
      this.dialogVisible = false;
    },
    add: function add() {
      this.$refs.addBanner.open({
        name: '新增',
        type: 'add',
        moduleId: this.id,
        mType: this.componentCode === 'bannerWithPuzzle' || this.componentCode === 'verticalBannerWithPuzzle' ? '2' : '',
        componentCode: this.componentCode,
        componentSubcode: this.componentSubcode,
        categoryId: this.categoryId
      });
    },
    detail: function detail(val, text, index) {
      if (text === 'noNeed') {
        this.$refs.addBanner.open({
          index: index,
          myKey: true,
          name: '编辑',
          type: 'upDate',
          moduleId: this.id,
          bannerId: val.bannerId,
          componentCode: this.componentCode,
          componentSubcode: this.componentSubcode,
          categoryId: this.categoryId
        });
      } else {
        this.$refs.addBanner.open({
          name: '编辑',
          type: 'upDate',
          moduleId: this.id,
          bannerId: val.bannerId,
          componentCode: this.componentCode,
          componentSubcode: this.componentSubcode,
          categoryId: this.categoryId
        });
      }
    },
    bannerBuff: function bannerBuff(val) {
      this.$refs.addBanner.open({
        name: '编辑营销位',
        type: 'upDate',
        moduleId: this.id,
        bannerId: val.categoryId,
        componentCode: this.componentCode
      });
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.name;
      this.componentSubcode = data.componentSubcode;
      this.componentCode = data.componentCode;
      this.id = data.id;
      if (this.componentCode === 'diamond' && this.componentSubcode === 's_a_c') {
        this.categoryId = data.categoryId;
      }
      this.findList();
      this.dialogVisible = true;
    },
    findList: function findList() {
      var _this5 = this;
      if (this.componentCode === 'diamond' && this.componentSubcode === 's_a_c') {
        (0, _customPage.diamondCategoryList)({
          categoryId: this.categoryId,
          bannerName: this.title,
          status: this.status
        }).then(function (res) {
          _this5.tableData = res.data.banner;
        });
      } else {
        (0, _customPage.moduleDetail)({
          moduleId: this.id,
          bannerName: this.title,
          status: this.status
        }).then(function (res) {
          console.log(res);
          if (_this5.componentCode === 'bannerWithPuzzle' || _this5.componentCode === 'verticalBannerWithPuzzle') {
            _this5.tableData = res.data.carouselBanner;
            _this5.puzzleList = res.data.banner;
          } else if (_this5.componentCode === 'bottomShopList') {
            _this5.tableData = res.data.bottomShopList.categoryList;
            _this5.shopListStyle = res.data.bottomShopList.shopListStyle;
          } else {
            _this5.tableData = res.data.banner;
          }
          if (_this5.componentCode === 'topSearch') {
            _this5.searchStyle = res.data.searchStyle * 1;
          } else if (_this5.componentCode === 'toolbar') {
            if (res.data.toolbarStyle !== null) {
              _this5.ruleForm = (0, _objectSpread2.default)({}, res.data.toolbarStyle);
            }
          }
        });
      }
    },
    clear: function clear() {
      this.title = '';
      this.status = '';
      this.findList();
    },
    search: function search() {
      this.findList();
    }
  }
};